// kapigen version 0.1.33
// eslint-disable
// namespace Kaggle.Sdk.Datasets.DataViewer:
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
export var DateTimeFilter;
(function(DateTimeFilter) {
    var DateTimeOperator;
    (function(DateTimeOperator) {
        DateTimeOperator["EQUALS"] = "equals";
        DateTimeOperator["LESS_THAN"] = "lessThan";
        DateTimeOperator["GREATER_THAN"] = "greaterThan";
        DateTimeOperator["LESS_EQUALS"] = "lessEquals";
        DateTimeOperator["GREATER_EQUALS"] = "greaterEquals";
    })(DateTimeOperator = DateTimeFilter.DateTimeOperator || (DateTimeFilter.DateTimeOperator = {}));
    var DateTimeOperatorWireFormat3 = DateTimeFilter.DateTimeOperatorWireFormat3 = {
        toJson: function toJson(enumVal) {
            switch(enumVal){
                case DateTimeOperator.EQUALS:
                case 0:
                default:
                    return "EQUALS";
                case DateTimeOperator.LESS_THAN:
                case 1:
                    return "LESS_THAN";
                case DateTimeOperator.GREATER_THAN:
                case 2:
                    return "GREATER_THAN";
                case DateTimeOperator.LESS_EQUALS:
                case 3:
                    return "LESS_EQUALS";
                case DateTimeOperator.GREATER_EQUALS:
                case 4:
                    return "GREATER_EQUALS";
            }
        }
    };
})(DateTimeFilter || (DateTimeFilter = {}));
export var NumericFilter;
(function(NumericFilter) {
    var NumericOperator;
    (function(NumericOperator) {
        NumericOperator["EQUALS"] = "equals";
        NumericOperator["LESS_THAN"] = "lessThan";
        NumericOperator["GREATER_THAN"] = "greaterThan";
        NumericOperator["LESS_EQUALS"] = "lessEquals";
        NumericOperator["GREATER_EQUALS"] = "greaterEquals";
    })(NumericOperator = NumericFilter.NumericOperator || (NumericFilter.NumericOperator = {}));
    var NumericOperatorWireFormat3 = NumericFilter.NumericOperatorWireFormat3 = {
        toJson: function toJson(enumVal) {
            switch(enumVal){
                case NumericOperator.EQUALS:
                case 0:
                default:
                    return "EQUALS";
                case NumericOperator.LESS_THAN:
                case 1:
                    return "LESS_THAN";
                case NumericOperator.GREATER_THAN:
                case 2:
                    return "GREATER_THAN";
                case NumericOperator.LESS_EQUALS:
                case 3:
                    return "LESS_EQUALS";
                case NumericOperator.GREATER_EQUALS:
                case 4:
                    return "GREATER_EQUALS";
            }
        }
    };
})(NumericFilter || (NumericFilter = {}));
export var StringFilter;
(function(StringFilter) {
    var StringOperator;
    (function(StringOperator) {
        StringOperator["IN"] = "in";
        StringOperator["EQUALS"] = "equals";
        StringOperator["CONTAINS"] = "contains";
    })(StringOperator = StringFilter.StringOperator || (StringFilter.StringOperator = {}));
    var StringOperatorWireFormat3 = StringFilter.StringOperatorWireFormat3 = {
        toJson: function toJson(enumVal) {
            switch(enumVal){
                case StringOperator.IN:
                case 0:
                default:
                    return "IN";
                case StringOperator.EQUALS:
                case 1:
                    return "EQUALS";
                case StringOperator.CONTAINS:
                case 2:
                    return "CONTAINS";
            }
        }
    };
})(StringFilter || (StringFilter = {}));
export var AndFilterWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.filters) {
            wireFormat.filters = message.filters.map(function(i) {
                return FilterWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
export var BooleanFilterWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var ColumnWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var ColumnFilterWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.column) {
            wireFormat.column = ColumnWireFormat3.toJson(message.column);
        }
        if (message === null || message === void 0 ? void 0 : message.booleanFilter) {
            wireFormat.booleanFilter = BooleanFilterWireFormat3.toJson(message.booleanFilter);
        }
        if (message === null || message === void 0 ? void 0 : message.numericFilter) {
            wireFormat.numericFilter = NumericFilterWireFormat3.toJson(message.numericFilter);
        }
        if (message === null || message === void 0 ? void 0 : message.dateTimeFilter) {
            wireFormat.dateTimeFilter = DateTimeFilterWireFormat3.toJson(message.dateTimeFilter);
        }
        if (message === null || message === void 0 ? void 0 : message.stringFilter) {
            wireFormat.stringFilter = StringFilterWireFormat3.toJson(message.stringFilter);
        }
        return wireFormat;
    }
};
export var ConstantFilterWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDataRaw = {
    data: "",
    totalBytes: 0,
    previewBytes: 0
};
export var DataRawWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDataRaw, wireFormat);
        if (wireFormat) {
            message.type = DataRawTypeWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalBytes) {
            message.totalBytes = parseInt(wireFormat.totalBytes);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.previewBytes) {
            message.previewBytes = parseInt(wireFormat.previewBytes);
        }
        return message;
    }
};
var defaultDataRow = {
    rowNumber: 0,
    text: []
};
export var DataRowWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDataRow, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rowNumber) {
            message.rowNumber = parseInt(wireFormat.rowNumber);
        }
        return message;
    }
};
var defaultDataTable = {
    totalRows: 0,
    rowsReturned: 0,
    rows: []
};
export var DataTableWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDataTable, wireFormat);
        if (wireFormat) {
            message.type = DataTableTypeWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalRows) {
            message.totalRows = parseInt(wireFormat.totalRows);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rows) {
            message.rows = wireFormat.rows.map(function(i) {
                return DataRowWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultDataUrl = {
    url: ""
};
export var DataUrlWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDataUrl, wireFormat);
        if (wireFormat) {
            message.type = DataUrlTypeWireFormat3.fromJson(wireFormat.type);
        }
        return message;
    }
};
var defaultDataView = {};
export var DataViewWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDataView, wireFormat);
        if (wireFormat) {
            message.type = DataViewTypeWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataTable) {
            message.dataTable = DataTableWireFormat3.fromJson(wireFormat.dataTable);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataUrl) {
            message.dataUrl = DataUrlWireFormat3.fromJson(wireFormat.dataUrl);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataRaw) {
            message.dataRaw = DataRawWireFormat3.fromJson(wireFormat.dataRaw);
        }
        return message;
    }
};
export var DateTimeFilterWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.operator) {
            wireFormat.operator = DateTimeFilter.DateTimeOperatorWireFormat3.toJson(message.operator);
        }
        if (message === null || message === void 0 ? void 0 : message.operand) {
            wireFormat.operand = message.operand.toISOString();
        }
        return wireFormat;
    }
};
export var FilterWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.columnFilter) {
            wireFormat.columnFilter = ColumnFilterWireFormat3.toJson(message.columnFilter);
        }
        if (message === null || message === void 0 ? void 0 : message.constantFilter) {
            wireFormat.constantFilter = ConstantFilterWireFormat3.toJson(message.constantFilter);
        }
        if (message === null || message === void 0 ? void 0 : message.andFilter) {
            wireFormat.andFilter = AndFilterWireFormat3.toJson(message.andFilter);
        }
        if (message === null || message === void 0 ? void 0 : message.orFilter) {
            wireFormat.orFilter = OrFilterWireFormat3.toJson(message.orFilter);
        }
        if (message === null || message === void 0 ? void 0 : message.notFilter) {
            wireFormat.notFilter = NotFilterWireFormat3.toJson(message.notFilter);
        }
        return wireFormat;
    }
};
var defaultGetDataViewResponse = {};
export var GetDataViewResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetDataViewResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataView) {
            message.dataView = DataViewWireFormat3.fromJson(wireFormat.dataView);
        }
        return message;
    }
};
export var NotFilterWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.filter) {
            wireFormat.filter = FilterWireFormat3.toJson(message.filter);
        }
        return wireFormat;
    }
};
export var NumericFilterWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.operator) {
            wireFormat.operator = NumericFilter.NumericOperatorWireFormat3.toJson(message.operator);
        }
        if ((message === null || message === void 0 ? void 0 : message.operand) != undefined && (message === null || message === void 0 ? void 0 : message.operand) != 0) {
            wireFormat.operand = Number.isFinite(message.operand) ? message.operand : Number(message.operand).toString();
        }
        return wireFormat;
    }
};
export var OrFilterWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.filters) {
            wireFormat.filters = message.filters.map(function(i) {
                return FilterWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
export var SortByWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.column) {
            wireFormat.column = ColumnWireFormat3.toJson(message.column);
        }
        if (message === null || message === void 0 ? void 0 : message.direction) {
            wireFormat.direction = SortDirectionWireFormat3.toJson(message.direction);
        }
        return wireFormat;
    }
};
export var StringFilterWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.operator) {
            wireFormat.operator = StringFilter.StringOperatorWireFormat3.toJson(message.operator);
        }
        return wireFormat;
    }
};
export var TableQueryWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.filter) {
            wireFormat.filter = FilterWireFormat3.toJson(message.filter);
        }
        if (message === null || message === void 0 ? void 0 : message.selectedColumns) {
            wireFormat.selectedColumns = message.selectedColumns.map(function(i) {
                return ColumnWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.sorts) {
            wireFormat.sorts = message.sorts.map(function(i) {
                return SortByWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
export var DataRawType;
(function(DataRawType) {
    DataRawType["MARKDOWN"] = "markdown";
    DataRawType["JSON"] = "json";
    DataRawType["TEXT"] = "text";
})(DataRawType || (DataRawType = {}));
export var DataRawTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "MARKDOWN":
            default:
                return DataRawType.MARKDOWN;
            case "JSON":
                return DataRawType.JSON;
            case "TEXT":
                return DataRawType.TEXT;
        }
    }
};
export var DataTableType;
(function(DataTableType) {
    DataTableType[// Table is a csv file in cloud storage.
    "CSV"] = "csv";
    DataTableType["BIGQUERY"] = "bigquery";
    DataTableType["SQLITE"] = "sqlite";
    DataTableType["EXCEL"] = "excel";
})(DataTableType || (DataTableType = {}));
export var DataTableTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "CSV":
            default:
                return DataTableType.CSV;
            case "BIGQUERY":
                return DataTableType.BIGQUERY;
            case "SQLITE":
                return DataTableType.SQLITE;
            case "EXCEL":
                return DataTableType.EXCEL;
        }
    }
};
export var DataUrlType;
(function(DataUrlType) {
    DataUrlType["IMAGE"] = "image";
    DataUrlType["PDF"] = "pdf";
    DataUrlType["AUDIO"] = "audio";
    DataUrlType["VIDEO"] = "video";
})(DataUrlType || (DataUrlType = {}));
export var DataUrlTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "IMAGE":
            default:
                return DataUrlType.IMAGE;
            case "PDF":
                return DataUrlType.PDF;
            case "AUDIO":
                return DataUrlType.AUDIO;
            case "VIDEO":
                return DataUrlType.VIDEO;
        }
    }
};
export var DataViewType;
(function(DataViewType) {
    DataViewType["TABULAR"] = "tabular";
    DataViewType["URL"] = "url";
    DataViewType["RAW"] = "raw";
})(DataViewType || (DataViewType = {}));
export var DataViewTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "TABULAR":
            default:
                return DataViewType.TABULAR;
            case "URL":
                return DataViewType.URL;
            case "RAW":
                return DataViewType.RAW;
        }
    }
};
export var SortDirection;
(function(SortDirection) {
    SortDirection["ASC"] = "asc";
    SortDirection["DESC"] = "desc";
})(SortDirection || (SortDirection = {}));
export var SortDirectionWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case SortDirection.ASC:
            case 0:
            default:
                return "ASC";
            case SortDirection.DESC:
            case 1:
                return "DESC";
        }
    }
};
